import { Carousel, Image } from "antd";
import "../../Styles/Web.css"

export const WebImages = ({text, images, title, left, color}) => {

    return (
        
        <div className="block" >
            <div className="block-content-50-50">
                {
                    left && 
                        <div className='responsive-50' style={{textAlign:'justify'}}>
                            <h1 className="block-title" style={{fontSize:'30px'}}>{title}<span style={{color:`${color}`}}>.</span></h1>                            
                            {text}
                        </div>
                }
                <div className='responsive-50'>
                    <Carousel>
                            {images?.map((mediaItem) => (
                                <div key={mediaItem.id}>
                                    <Image style={{borderRadius:'10px'}} src={mediaItem.googleUrl}/>
                                </div>
                            ))}
                    </Carousel>
                </div>
                {
                    !left && 
                        <div className='responsive-50' style={{textAlign:'justify'}}>
                            <h1>{title}<span style={{color:`${color}`}}>.</span></h1>
                            {text}
                        </div>
                }
            </div>
        </div>
    )
}